export function stripJavascript(text: string): string {
    return (text || '').replace(/javascript|script/gmi, 'manananggal')
}